module.exports = __webpack_public_path__ + "img/genshin.f0bed41.jpg";